var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m1.612 2.028-.538 3.224A.9.9 0 0 0 1.962 6.3h.803a1.35 1.35 0 0 0 1.208-.746L4.5 4.5l.527 1.054a1.35 1.35 0 0 0 1.207.746h1.031a1.35 1.35 0 0 0 1.208-.746L9 4.5l.527 1.054a1.35 1.35 0 0 0 1.207.746h1.031a1.35 1.35 0 0 0 1.208-.746L13.5 4.5l.527 1.054a1.35 1.35 0 0 0 1.207.746h.803a.9.9 0 0 0 .888-1.048l-.537-3.224A1.35 1.35 0 0 0 15.056.9H2.943a1.35 1.35 0 0 0-1.331 1.128M16.2 8.1H1.8v7.65c0 .746.604 1.35 1.35 1.35H6.3v-6.3h5.4v6.3h3.15a1.35 1.35 0 0 0 1.35-1.35z"
})));
export { SvgStore as ReactComponent };
export default __webpack_public_path__ + "static/media/store.629601fd.svg";